import { useMemo } from "react";

const IncrementalButton = ({
  value,
  onChangeValue = () => {},
  onIncrease = () => {},
  onDecrease = () => {},
  size = "md",
  min = 1,
  max = 99,
  ...props
}) => {
  const canDecrease = useMemo(
    () => min === null || (value > min && min !== null),
    [value, min],
  );
  const canIncrease = useMemo(
    () => max === null || (value < max && max !== null),
    [value, max],
  );

  const handleIncrease = () => {
    if (canIncrease) {
      if (onChangeValue) {
        onChangeValue(value + 1);
      }

      if (onIncrease) {
        onIncrease();
      }
    }
  };

  const handleDecrease = () => {
    if (canDecrease) {
      if (onChangeValue) {
        onChangeValue(value - 1);
      }
      if (onDecrease) {
        onDecrease();
      }
    }
  };

  return (
    <div
      className="flex items-center bg-gray-200 rounded-full w-full sm:w-auto"
      {...props}
    >
      <button
        disabled={!canDecrease}
        onClick={handleDecrease}
        className={`border-1 text-xl select-none hover:bg-gray-300 hover:scale-105 rounded-full transition-colors ${size === "sm" ? "w-10 h-10" : "w-14 h-14"}`}
      >
        -
      </button>
      <span
        className={`px-1 flex-grow text-center font-bold select-none ${size === "sm" ? "min-w-8" : "min-w-12"}`}
      >
        {value}
      </span>
      <div>
        <button
          disabled={!canIncrease}
          onClick={handleIncrease}
          className={`border-1 text-xl select-none hover:bg-gray-300 hover:scale-105 rounded-full transition-colors ${size === "sm" ? "w-10 h-10" : "w-14 h-14"}`}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default IncrementalButton;
